import { createMetricsFactory } from 'metrics-js';
import { getAppName } from './app';
export const Metrics = createMetricsFactory(getAppName() || 'academy-common-lib');